module.exports = __webpack_public_path__ + "img/bureau-black.13775101.png";